import { useContext } from 'react'
import { UserContext, UserContextType } from '../store/Store'

export const useCurrentUser = () => {
    return useContext<UserContextType>(UserContext)
}
